<template>
  <div>
    <a-spin :spinning="loading">
      <div class="card">
        <div class="card-body">
          <h5 class="mb-4">
            <strong>My profile</strong>
          </h5>
          <a-row>
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
              <a-form-model ref="ruleForm" :model="form" :rules="rules">
                <a-form-model-item
                  ref="userName"
                  prop="userName"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Username (email)"
                  @blur="
                    () => {
                      $refs.userName.onFieldBlur()
                    }
                  "
                >
                  <a-input v-model="form.userName" />
                </a-form-model-item>
                <a-form-model-item
                  ref="firstName"
                  prop="firstName"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="First name"
                  @blur="
                    () => {
                      $refs.firstName.onFieldBlur()
                    }
                  "
                >
                  <a-input v-model="form.firstName" />
                </a-form-model-item>

                <a-form-model-item
                  ref="lastName"
                  prop="lastName"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Last name"
                  @blur="
                    () => {
                      $refs.lastName.onFieldBlur()
                    }
                  "
                >
                  <a-input v-model="form.lastName" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Display name"
                >
                  <a-input
                    v-model="displayName"
                    disabled
                    style="background-color: white !important; color: black"
                  />
                </a-form-model-item>

                <div class="float-right">
                  <a-space :space="16">
                    <a-button @click="resetPassword" type="danger">
                      Reset password
                    </a-button>
                    <a-button @click="onSubmit" class="btn btn-success">
                      Save
                    </a-button>
                  </a-space>
                </div>
              </a-form-model>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Col, Row, Space } from 'ant-design-vue'
Vue.use(Space, Row, Col, Button)

import { mapState, mapGetters } from 'vuex'
import { UserService, ParticipantService } from '@/services/api'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 20 },
}

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      labelCol,
      wrapperCol,
      loading: true,

      allParticipants: [],
      rules: {
        firstName: [
          {
            required: true,
            message: 'Please input First name',
            trigger: 'blur',
          },
        ],
        lastName: [
          {
            required: true,
            message: 'Please input Last name',
            trigger: 'blur',
          },
        ],
        userName: [
          {
            required: true,
            message: 'Please input Username (email address)',
            trigger: 'blur',
          },
        ],
      },
      form: {
        firstName: '',
        lastName: '',
        userName: '',
      },
    }
  },
  methods: {
    resetPassword() {
      UserService.resetPassword(this.user.id).then((response) => {
        this.$notification.success({
          message: 'Mail sent',
          description: `We have sent email for password reset. Please follow instruction in email.`,
        })
      })
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true

          var dataToSend = {
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            username: this.form.userName,
          }

          UserService.update(this.user.id, dataToSend).then((response) => {
            this.$notification.success({
              message: 'User update',
              description: `User details have been updated successfully.`,
            })
            this.getData()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getData() {
      UserService.get(this.user.id).then((response) => {
        this.form.firstName = response.data.data.firstName
        this.form.lastName = response.data.data.lastName
        this.form.userName = response.data.data.username
        this.loading = false
      })
    },
  },
  watch: {},
  computed: {
    // a computed getter
    ...mapGetters('user', ['user']),
    displayName: function () {
      // `this` points to the vm instance
      return this.form.firstName + ' ' + this.form.lastName
    },
  },
  mounted() {
    this.getData()
  },
}
</script>
